module.exports = __webpack_public_path__ + "static/media/sofive.ebcd9e74.png";